import { Box, BoxProps } from '@mui/material';
import { FC } from 'react';

export const FlexBox: FC<BoxProps> = (props) => <Box display="flex" flexGrow={1} {...props} />;
